/** Default copy for the public “Message to guests” block (admin can override). */
export const GUEST_SECTION_DEFAULTS = {
  guest_section_title: 'TO OUR GUESTS',
  guest_section_body:
    'We are so grateful you are part of our celebration. Everything you need to plan your visit is right below.',
};

export function guestSectionFromSettings(settings) {
  const title = String(settings?.guest_section_title ?? GUEST_SECTION_DEFAULTS.guest_section_title).trim();
  const body = String(settings?.guest_section_body ?? GUEST_SECTION_DEFAULTS.guest_section_body).trim();
  return { title, body };
}
